import { useEffect, useState } from 'react';

import { VersionDto } from 'lib_api/lib/api/gen';

import { useApi } from 'hooks/ApiStoreContext';

export const useVersion = (): VersionDto | undefined => {
  const { VersionControllerApi } = useApi();
  const [version, setVersion] = useState<VersionDto>();

  useEffect(() => {
    VersionControllerApi.getVersionUsingGET()
      .then(versionDto => {
        setVersion(versionDto);
      })
      .catch((errorResponse: Response): void => {
        // in theory if fourriere-api is down, the whole front is down
        console.error(errorResponse);
      });
  }, [VersionControllerApi, setVersion]);

  return version;
};
